import React, { useEffect, useState } from "react";


import {
    Box,
    Card,
    CardContent,
    Typography,
    Stack,
    Divider,
    } from "../ui";
import { useSelector } from "react-redux";
import SnpComponent from "../global/SnpComponent";

import { useNavigate } from "react-router-dom";
import SnpButton from "../global/SnpButton";
import { getBaseNotification,
    setBaseNotificationRead } from "../dashboard/dashboardNetworkController";
import {
  getAuthSession,
  isEmpty
} from "../../constants/constant";

export default function SnpNotificationScreen({ onReadClick }) {

    const storeApiUrl = useSelector(
        (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
    );

    const storeActiveShopHash = useSelector(
        (state) => state.setActiveShopHashReducer.activeShopHash
    );
    const [loader, setLoader] = useState(false);
    const [listNotifications, setListNotifications] = useState([]);
    const navigate = useNavigate();


    const getNotifications = async (read) => {
        try {
            setLoader(true);
            await getBaseNotification(storeApiUrl.BACKEND_BASE_URL, storeActiveShopHash, read, false, (datas) => {
                setListNotifications(datas);
            })
        } catch (error) {
            console.error("getNotifications", error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getNotifications(false);
    }, [storeActiveShopHash, storeApiUrl]);


    const handleGoBack = () => {
        navigate("/dashboard");
    }

    const handleOnClickNotification = async (n) => {
        await setBaseNotificationRead(storeApiUrl.BACKEND_BASE_URL,
            getAuthSession().apiToken,
            storeActiveShopHash.cartType,
            n.id);
        onReadClick();
        if (!isEmpty(n.path)) {
            navigate(n.path);
        } else {
            getNotifications(false);
        }
    }

    const renderSnpContent = () => {
        return (
            <>
                <Box>
                    <SnpButton variant="contained"
                        color="primary" onPointerDown={() => handleGoBack()}>
                        Go Back
                    </SnpButton>
                    {
                        listNotifications.length === 0 &&
                        <p style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                            No notifications found ....
                        </p>
                    }
                    <Stack
                        sx={{ mt: 2 }}
                        spacing={2} >
                        {listNotifications.map((n, i) => (
                            <Card
                                key={i}
                                elevation={3}
                                sx={{ borderRadius: 3, padding: 1 }}
                            >
                                <CardContent>
                                    <Typography variant="h6"
                                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                    >{n.title}</Typography>

                                    <Typography
                                        variant="p"
                                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                        color="#4a4e69"
                                        sx={{ mb: 1 }}
                                    >
                                        {n.message}
                                    </Typography>

                                    <Divider sx={{ my: 1 }} />

                                    <Typography variant="caption" color="gray" display="block">
                                        Added On: {n.addedOn}
                                    </Typography>
                                    {
                                        !isEmpty(n.seenByUser)
                                        && <Typography variant="caption" color="gray" display="block">
                                            Seen By: {n.seenByUser}
                                        </Typography>
                                    }
                                    {
                                        !isEmpty(n.seenOn) &&
                                        <Typography variant="caption" color="gray" display="block">
                                            Seen On: {n.seenOn}
                                        </Typography>
                                    }

                                    <Box mt={2}>
                                        <SnpButton
                                            variant="contained"
                                            mbgcolor="#538796"
                                            fullWidth
                                            onPointerDown={() => handleOnClickNotification(n)}
                                        >
                                            Preview
                                        </SnpButton>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))}
                    </Stack>
                </Box>
            </>
        )
    };


    return (
        <SnpComponent
            isLoader={loader}
            content={renderSnpContent()}
        />
    );

}
